import {
  getJobApplicationsConstants,
  updateJobApplicationConstants,
  cancelRejectionEmailConstants,
  createJobApplicationAdminConstants,
  deleteJobApplicationConstants,
  sendInterviewInviteConstants,
} from '../constants/jobApplicationsConstants';

const { createFetchStandartFlowActionCreators } = require('../../utils/helpers/actionCreatorHelpers');

export const getJobApplicationsActionCreators = createFetchStandartFlowActionCreators(
  getJobApplicationsConstants,
);

export const updateJobApplicationActionCreators = createFetchStandartFlowActionCreators(
  updateJobApplicationConstants,
);

// eslint-disable-next-line import/prefer-default-export
export const cancelRejectionEmailActionCreators = createFetchStandartFlowActionCreators(
  cancelRejectionEmailConstants,
);

export const createJobApplicationAdminActionCreators = createFetchStandartFlowActionCreators(
  createJobApplicationAdminConstants,
);

export const deleteJobApplicationActionCreators = createFetchStandartFlowActionCreators(
  deleteJobApplicationConstants,
);

export const sendInterviewInviteActionCreators = createFetchStandartFlowActionCreators(
  sendInterviewInviteConstants,
);
